import { Box, IconButton, Typography } from "@mui/material";
import { FC } from "react";
import CloseIcon from "@mui/icons-material/Close";

const sxStyles = {
  header: {
    display: "flex",
    justifyContent: "space-between",
    margin: "1rem 1.5rem",
    alignItems: "center",
  },
};

interface DrawerHeaderProps {
  title: string;
  subtitle?: string;
  onClose: () => void;
}

const DrawerHeader: FC<DrawerHeaderProps> = ({ title, subtitle, onClose }) => {
  return (
    <Box sx={sxStyles.header}>
      <Box>
        <Typography sx={{ fontWeight: "bold", fontSize: "1.25rem" }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="caption" sx={{ fontSize: "0.875rem" }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      <IconButton sx={{ alignSelf: "flex-start" }} onClick={onClose}>
        <CloseIcon />
      </IconButton>
    </Box>
  );
};

export default DrawerHeader;
